import React, { useState } from "react"
import { Paper, Stack, Box, useTheme } from "@mui/material"
import { useNavigate, useOutletContext } from "react-router-dom"
import ButtonWithIcon from "src/v2/components/Button/Button"
import { ReactComponent as TrashIcon } from "src/v2/assets/icons/trash-icon.svg"
import { ReactComponent as CopyIcon } from "src/v2/assets/icons/copy-icon.svg"
import { ReactComponent as PasteIcon } from "src/v2/assets/icons/paste-icon.svg"
import { ReactComponent as CheckIcon } from "src/v2/assets/icons/check-icon.svg"
import { eventosOrdinariosFields } from "./eventos-ordinarios-fields"
import { DynamicColumnTable } from "../componentes/dynamic-column-table"
import FormActions from "../../components/FormActions"


export const EventosOrdinariosPage = () => {
    const theme = useTheme()
    const navigate = useNavigate()

    const [tableData, setTableData] = useState([{}])

    const handleCellChange = ({ rowIndex, colIndex, value }) => {
        const newData = [...tableData]

        if (rowIndex === -1) {
            newData[colIndex] = {
                ...newData[colIndex],
                [eventosOrdinariosFields[0].key]: value,
            }

            if(colIndex === newData.length - 1){
                newData.push({})
            }
        } else {
            const fieldKey = eventosOrdinariosFields[rowIndex + 1]?.key
            newData[colIndex] = {
                ...newData[colIndex],
                [fieldKey]: value,
            }
        }

        setTableData(newData)
    }

    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false)
    const { caracteristicaState } = useOutletContext() || {}
    // se tiver ID, é produção (true). Se não tiver, é temporário (false).
    const isPublished = Boolean(caracteristicaState?.ID)

    const handleSave = () => {
        console.log("Salvando dados...")
        // Aqui entraria a chamada da api
    }

    const handlePublish = () => {
        console.log("Publicando evento...")
    }

    const handleDelete = () => {
        console.log("Deletando registro...")
        setDeleteConfirmOpen(false)
        navigate(-1) // volta para a tela anterior após deletar
    }

    return (
        <Paper sx={{ p: 2 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <ButtonWithIcon icon={<TrashIcon />} size="md">
                    LIMPAR
                </ButtonWithIcon>

                <Stack direction="row" spacing={2}>
                    <ButtonWithIcon icon={<CopyIcon />} size="md">
                        COPIAR
                    </ButtonWithIcon>

                    <ButtonWithIcon icon={<PasteIcon />} size="md">
                        COLAR
                    </ButtonWithIcon>
                </Stack>
            </Stack>

            <Stack sx={{ mt: 2 }}>
                <DynamicColumnTable
                    fields={eventosOrdinariosFields}
                    items={tableData}
                    onCellChange={handleCellChange}
                />
            </Stack>

            <Box sx={{ mx: { xxxs: -3, md: -3, lg: 0 }, mt: 4 }}>
                <FormActions
                    showBack
                    onBack={() => navigate(-1)}

                    onDelete={() => setDeleteConfirmOpen(true)}
                    deleteOpen={deleteConfirmOpen}
                    setDeleteOpen={setDeleteConfirmOpen}
                    onConfirmDelete={handleDelete}


                    showSave={!isPublished}
                    onSave={handleSave}

                    onPublish={handlePublish}
                    publishLabel={isPublished ? "SALVAR E PUBLICAR" : "PUBLICAR"}
                    publishIcon={<CheckIcon />}

                    theme={theme} />
            </Box>
        </Paper>
    )
}
